// Key order drives the Content Creator text-kind dropdown, so the social
// channels stay grouped together at the top.
const KindType = Object.freeze({
  facebookPost: 'facebookPost',
  instagramPost: 'instagramPost',
  linkedinPost: 'linkedinPost',
  gmbNewsPost: 'gmbNewsPost',
  gmbProductDescription: 'gmbProductDescription',
  whatsappStatus: 'whatsappStatus',
  newsletter: 'newsletter',
  facebookAds: 'facebookAds',
  customerMailing: 'customerMailing',
  blogPost: 'blogPost',
  websiteText: 'websiteText',
  interview: 'interview',
})

export const ReadableKindType = Object.freeze({
  facebookPost: 'Facebook Post',
  instagramPost: 'Instagram Post',
  linkedinPost: 'LinkedIn Post',
  newsletter: 'Newsletter',
  facebookAds: 'Facebook Ads',
  gmbNewsPost: 'Google Unternehmensprofil Newspost',
  gmbProductDescription: 'Google Unternehmensprofil Produktbeschreibung',
  customerMailing: 'Kundenanschreiben',
  websiteText: 'Webseiten Text',
  interview: 'Interview',
  whatsappStatus: 'WhatsApp Status',
})

export const KindTypeIcon = Object.freeze({
  facebookPost: '/img/kindTypes/facebook.png',
  instagramPost: '/img/kindTypes/instagram.png',
  linkedinPost: '/img/kindTypes/linkedin.png',
  facebookAds: '/img/kindTypes/facebook.png',
  newsletter: '/img/kindTypes/email.png',
  gmbNewsPost: '/img/kindTypes/google-business.svg',
  gmbProductDescription: '/img/kindTypes/google-business.svg',
  customerMailing: '/img/kindTypes/email.png',
  blogPost: '/img/kindTypes/blog-post.png',
  websiteText: '/img/kindTypes/website-text.png',
  interview: '/img/kindTypes/interview.png',
  whatsappStatus: '/img/kindTypes/whatsapp.svg',
  all: '/img/kindTypes/settings.png',
})

/**
 * `buildUrlWithTracking` lowercases these values into the `utm_source` of every
 * published link, so they must stay stable.
 *
 * For anything a user reads, resolve `ReadableSocialMedia` instead (via
 * `KindToType` when you only have a text kind).
 */
export const KindName = Object.freeze({
  facebookPost: 'Facebook',
  instagramPost: 'Instagram',
  linkedinPost: 'LinkedIn',
  gmbNewsPost: 'Google Business',
  newsletter: 'Newsletter',
})

export const TypeToKind = Object.freeze({
  FACEBOOK: 'facebookPost',
  INSTAGRAM: 'instagramPost',
  LINKEDIN: 'linkedinPost',
  GOOGLE_BUSINESS: 'gmbNewsPost',
  WHATSAPP_STATUS: 'whatsappStatus',
  NEWSLETTER: 'newsletter',
})

// Not derived from TypeToKind: the mapping is many-to-one, because both Google
// Business text kinds post to the same channel.
export const KindToType = Object.freeze({
  facebookPost: 'FACEBOOK',
  instagramPost: 'INSTAGRAM',
  linkedinPost: 'LINKEDIN',
  gmbNewsPost: 'GOOGLE_BUSINESS',
  gmbProductDescription: 'GOOGLE_BUSINESS',
  whatsappStatus: 'WHATSAPP_STATUS',
  newsletter: 'NEWSLETTER',
})

export default KindType
